/**
 * Created by rorschach on 2018/1/29.
 */
import React from "react";

class ReactComponent extends React.Component {
  getWrappedInstance() {
    return this.refs["instance"];
  }
}
export default ReactComponent;



// WEBPACK FOOTER //
// ./src/xyui/ReactComponent.js